const BlogDetailsSection3 = () => {
  return (
    <section className="about about--style1 bg-color xts-section py-10 px-6">
      <div className="container max-w-4xl mx-auto py-5">
        <h1 className="text-3xl text-center font-bold pb-4 text-gray-800">
          Building Confidence in the Age of Automation: Why Compliance Is Your Best Strategy
        </h1>
        <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
          <div className="col-lg-6">
            <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
              <div className="about__thumb-inner">
                <div className="about__thumb-image floating-content">
                  <img className="dark w-100" src="assets/images/blog/image-3.jpg" alt="about-image" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about__content" data-aos="fade-left" data-aos-duration="800">
              <div className="about__content-inner">
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  In today’s AI-driven markets, speed and automation dominate the headlines — but what truly sustains success is 
                  <strong> compliance and credibility</strong>.
                </p>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  At <strong>Asiatic Stock & Securities</strong>, every strategy, order, and platform integration is built on 
                  SEBI-aligned governance, ensuring your trading remains transparent, secure, and fully compliant.
                </p>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  While algorithms can find opportunities, only trust and regulatory discipline protect your capital in the long run.
                  Our experience ensures you never have to choose between innovation and integrity.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed font-semibold">
                  Technology gives you speed. Compliance gives you safety — together, they create confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailsSection3;
